import { useMemo } from 'react';
import { useControlUnitsById } from './useControlUnitsById';

/**
 * Get and fetch control unit from specified device
 * @param deviceId
 * @param controlUnitId
 * @returns QueryResult
 * 
 * @usage
```ts
const {
    data: controlUnits,
    error: errorControlUnits,
    isLoading: loadingControlUnits,
  }  = useControlUnitsById("UUUID_DEVICE", "1003")
```
 */
export function useControlUnitById(deviceId?: string, controlUnitId?: string) {
  const response = useControlUnitsById({
    deviceId,
  });
  const controlUnit = useMemo(
    () => response.data?.find((cu) => cu.id === controlUnitId),
    [response.data, controlUnitId]
  );
  return {
    ...response,
    data: controlUnit,
  };
}
